import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range } from 'underscore';
import Checkbox from '../field/checkbox';

const checkboxes = [
  {
    value: '',
    label: 'Any'
  },
  {
    value: 'AFRIKA',
    label: 'Afrikaans'
  },
  {
    value: 'ALBAN',
    label: 'Albanian'
  },
  {
    value: 'ARABIC',
    label: 'Arabic'
  },
  {
    value: 'ARMEN',
    label: 'Armenian'
  },
  {
    value: 'ASL',
    label: 'Amer. Sign Lang.'
  },
  {
    value: 'BENG',
    label: 'Bengali'
  },
  {
    value: 'BOS',
    label: 'Bosnian'
  },
  {
    value: 'BULGAR',
    label: 'Bulgarian'
  },
  {
    value: 'CHINES',
    label: 'Chinese'
  },
  {
    value: 'CROAT',
    label: 'Croatian'
  },
  {
    value: 'CZCH',
    label: 'Czech'
  },
  {
    value: 'DANISH',
    label: 'Danish'
  },
  {
    value: 'DUTCH',
    label: 'Dutch'
  },
  {
    value: 'ENGLIS',
    label: 'English'
  },
  {
    value: 'ESTON',
    label: 'Estonian'
  },
  {
    value: 'FARSI',
    label: 'Farsi'
  },
  {
    value: 'FILIP',
    label: 'Filipino'
  },
  {
    value: 'FINNIS',
    label: 'Finnish'
  },
  {
    value: 'FRENCH',
    label: 'French'
  },
  {
    value: 'GAELIC',
    label: 'Gaelic'
  },
  {
    value: 'GEOR',
    label: 'Georgian'
  },
  {
    value: 'GERMAN',
    label: 'German'
  },
  {
    value: 'GREEK',
    label: 'Greek'
  },
  {
    value: 'HAW',
    label: 'Hawaiian'
  },
  {
    value: 'HEBREW',
    label: 'Hebrew'
  },
  {
    value: 'HINDI',
    label: 'Hindi'
  },
  {
    value: 'HUNGAR',
    label: 'Hungarian'
  },
  {
    value: 'INDON',
    label: 'Indonesian'
  },
  {
    value: 'ITALIA',
    label: 'Italian'
  },
  {
    value: 'JAPAN',
    label: 'Japanese'
  },
  {
    value: 'KOREAN',
    label: 'Korean'
  },
  {
    value: 'LAO',
    label: 'Lao'
  },
  {
    value: 'LATVIA',
    label: 'Latvian'
  },
  {
    value: 'LITHU',
    label: 'Lithuanian'
  },
  {
    value: 'MALAY',
    label: 'Malay'
  },
  {
    value: 'MANDR',
    label: 'Mandarin'
  },
  {
    value: 'NEPAL',
    label: 'Nepali'
  },
  {
    value: 'NORWEG',
    label: 'Norwegian'
  },
  {
    value: 'POLISH',
    label: 'Polish'
  },
  {
    value: 'PORTU',
    label: 'Portuguese'
  },
  {
    value: 'PUNJA',
    label: 'Punjabi'
  },
  {
    value: 'ROMAN',
    label: 'Romanian'
  },
  {
    value: 'RUSSIA',
    label: 'Russian'
  },
  {
    value: 'SERB',
    label: 'Serbian'
  },
  {
    value: 'SINDHI',
    label: 'Sindhi'
  },
  {
    value: 'SINGH',
    label: 'Singhalese'
  },
  {
    value: 'SLVK',
    label: 'Slovak'
  },
  {
    value: 'SLOVEN',
    label: 'Slovenian'
  },
  {
    value: 'SPANIS',
    label: 'Spanish'
  },
  {
    value: 'SWAHIL',
    label: 'Swahili'
  },
  {
    value: 'SWED',
    label: 'Swedish'
  },
  {
    value: 'TAGALG',
    label: 'Tagalog'
  },
  {
    value: 'TAIWAN',
    label: 'Taiwanese'
  },
  {
    value: 'THAI',
    label: 'Thai'
  },
  {
    value: 'TURKIS',
    label: 'Turkish'
  },
  {
    value: 'UKRAIN',
    label: 'Ukrainian'
  },
  {
    value: 'URDU',
    label: 'Urdu'
  },
  {
    value: 'VIETNA',
    label: 'Vietnamese'
  },
  {
    value: 'YUGO',
    label: 'Yugoslavian'
  }
];

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);
  return (
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

class LanguageFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const { className, numCols, numInnerCols, ...props } = this.props;
    const colSize = Math.ceil(12 / numCols);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const numPerCol = Math.ceil(checkboxes.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const data = checkboxes[i];
                          i++;
                          return data ? (
                            <RenderCheckbox
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={data.value !== undefined ? data.value : data}
                              label={data.label || data}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }
}

LanguageFilter.defaultProps = {
  numCols: 3,
  numInnerCols: 2
};

export default LanguageFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/language-filter.js